import React from "react";
import FilingAssistantMenu from "./FilingAssistantMenu";

export default function HeaderActions({
    tab,
    company,
    isFAMenuVisible,
    setFAMenuVisible,
    onAccurateFileName,
    onAccurateFolderName,
    onClickFileReportHistory,
    onClickViewUnallocatedFiles,
    checkDuplicatedFiles,
    onClickDeduperReportHistory,
}) {
    return (
        <div className="dg gtcr4-md gg0-5rem btn-dataroom-saf mah3rem">
            {tab === "kitemark" ? (
                <>
                    <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Kitemark Audit</span>
                    <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Kitemark Report</span>
                    <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Digital Certificate</span>
                    <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Full Report</span>
                    <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Report by Section</span>
                </>
            ) : (
                <>
                    {tab == 'repository' && (!company?.['modules']?.[tab]?.isHealthBoost) && (
                        <FilingAssistantMenu
                            isVisible={isFAMenuVisible}
                            setVisible={setFAMenuVisible}
                            onAccurateFileName={onAccurateFileName}
                            onAccurateFolderName={onAccurateFolderName}
                            onClickFileReportHistory={onClickFileReportHistory}
                            onClickViewUnallocatedFiles={onClickViewUnallocatedFiles}
                            checkDuplicatedFiles={checkDuplicatedFiles}
                            onClickDeduperReportHistory={onClickDeduperReportHistory}
                        />
                    )}
                </>
            )}
        </div>
    );
}
